// Setup Vue
import { createApp } from 'vue'
window.Vue = createApp;
window.$ = window.jQuery = jQuery;

// Our extensions and components
import Axios from './classes/Axios.js';
import modalDynamic from './components/modal-dynamic.vue';
import TimecardMixin from './mixins/TimecardMixin';
import UtilitiesMixin from './mixins/UtilitiesMixin';
import COAMixin from './mixins/COAMixin.js';
import calendar from './components/calendar.vue';
import oasisModal from './components/oasis-modal.vue';
import AgGrid from './components/AgGrid.vue';
import Roster from './components/Roster.vue';
import Edits from './components/Edits.vue';
import DateFormatUtil from './mixins/DateFormatUtil.js';
// import autocomplete from './components/autocomplete.vue';
// import DateField from './components/DateField.vue';
import { DateTime } from 'luxon';
import { debounce } from 'lodash';
require('./classes/PrototypeExt.js');

var app = createApp({

    components: {
        calendar,
        'modal-dynamic': modalDynamic,
        'oasis-modal': oasisModal,
        AgGrid,
        Roster,
        Edits,
    },

    mixins: [TimecardMixin, UtilitiesMixin, COAMixin, DateFormatUtil],

    data() {
        return {
            unApprovedSelectedTimecards: new Map(),
            selectedTimecardsEmail: new Map(),
            selectedOpenTimecardsEmail: new Map(),
            selectedApprovedTimecardsEmail: new Map(),
            selectedSubmittedTimecardsEmail: new Map(),
            // to save sent email data
            sentAllEmails: new Set(),
            true: true,  // necessary to pass a boolean true and not a string
            false: false,  // necessary to pass a boolean true and not a string
            waiting: false, // whole-page spinner
            loading: false, // spinner
            adminAccess: false,
            proPayPayrollId: null,
            showTimecardDetail: false,
            terminationModal: false,
            batchModal: false,
            addBatchModal: false,
            modals: [],  // Dynamic modals
            openModals: 0,  // Dynamic modals counting
            buttonYesAction: [],
            buttonNoAction: [],
            button3Action: [],
            oasisApi: new Axios('/restv2'),
            oasisApiProd: new Axios('https://www.revolutiones.com/oasis/restv2'),
            propayFrontend: '',
            format: 'MM/dd/yyyy',

            tcSortMethodToApprove: '',
            tcSortMethodOpen: '',
            tcSortMethodApproved: '',
            tcSortMethodSearch: '',

            // employees/locations retrieved from database
            employees: [],
            timecards: undefined,
            timecardsOpen: undefined,
            timecardsMissing: undefined,
            timecardsApproved: undefined,
            timecardsSubmitted: undefined,
            timecardReviews: undefined,
            timecardsSearch: [],
            timecardsSearchMap: {},
            departments: [],
            entity: undefined,
            entityId: entityId,
            batches: [],
            move_batch: {
                id: undefined, // When we move a batch
                name: undefined, // When we move a batch
            },
            showBatches: showBatches,
            showEdits: false,
            hideMissingTimecards: false,
            seeMyDepartmentOnlyI9: true,
            weekEnding: '',

            statusFilterToApprove: '',
            statusesToApprove: [],
            reviewFilterToApprove: '',
            reviewsToApprove: [],
            batchesFilterToApprove: '',
            batchesToApprove: [],
            batchesFilterToOpen: '',
            batchesToOpen: [],
            batchesFilterToApproved: '',
            batchesToApproved: [],
            showFilterToApprove: '',
            showsToApprove: [],
            departmentFilterToApprove: '',
            departmentsToApprove: [],
            accountFilterToApprove: '',
            accountsToApprove: [],
            weekFilterToApprove: '',
            weekEndingsToApprove: [],
            unionFilterToApprove: '',
            unionsToApprove: [],

            statusFilterNew: '',
            statusesNew: [],
            reviewFilterNew: '',
            reviewsNew: [],
            batchesFilterNew: '',
            batchesNew: [],
            showFilterNew: '',
            showsNew: [],
            departmentFilterNew: '',
            departmentsNew: [],
            accountFilterNew: '',
            accountsNew: [],
            weekFilterNew: '',
            weekEndingsNew: [],
            unionFilterNew: '',
            unionsNew: [],

            /*
            statusFilterNew: '',
            statusesNew: [],
            showFilterNew: '',
            showsNew: [],
            weekFilterNew: '',
            weekEndingsNew: [],
            */

            statusFilterApproved: '',
            statusesApproved: [],
            batchesFilterApproved: '',
            batchesApproved: [],
            showFilterApproved: '',
            showsApproved: [],
            departmentFilterApproved: '',
            departmentsApproved: [],
            accountFilterApproved: '',
            accountsApproved: [],
            weekFilterApproved: '',
            weekEndingsApproved: [],
            unionFilterApproved: '',
            unionsApproved: [],

            batchesFilterSearch: '',
            batchesSearch: [],
            employeeFilterSearch: '',
            employeesSearch: [],
            showFilterSearch: '',
            showsSearch: [],
            departmentFilterSearch: '',
            departmentsSearch: [],

            weekFilterSearch: '',
            weekEndingsSearch: [],
            unionFilterSearch: '',
            unionsSearch: [],

            // Checkbox details for timecards
            selectedTimecards: [],
            selectedOpenTimecards: [],
            selectedApprovedTimecards: [],
            selectedSubmittedTimecards: [],
            selectedMissingTimecards: [],

            // Starts
            allStarts: [],
            waitingStarts: undefined,
            unsentStarts: undefined,
            readyToApproveStarts: undefined,
            completedStarts: [],
            recentlyCompletedStarts: [],
            needingI9Starts: undefined,
            terminatedStarts: [],
            openStarts: undefined,

            certifiedEmployees: [],
            certifiedStatus: false,
            certifiedSupervisor: undefined,

            sortMethodStarts: '',
            statusFilterStarts: '',
            statusesStarts: [],
            batchesFilterStarts: '',
            batchesStarts: [],
            departmentFilterStarts: '',
            departmentsStarts: [],
            unionLocalFilterStarts: '',
            unionLocalStarts: [],

            // Checkbox details for starts
            selectedWaitingStarts: [],
            selectedUnsentStarts: [],
            selectedReadyToApproveStarts: [],
            selectedCompletedStarts: [],
            selectedRecentlyCompletedStarts: [],
            selectedNeedingI9Starts: [],
            selectedTerminatedStarts: [],
            selectedAllStarts: [],
            selectedOpenStarts: [],
            selectedCertifications: [],
            selectedFilteredStarts: [],

            // Edits
            edits: [],
            selectedEdits: [],

            reportServer: 'https://jasper.revolutiones.com:8443/jasperserver/rest_v2/reports/Revolution/Phoenix/',
            showJson: false,
            jsonOverride: {},
            termDate: '',
            terminationMessage: '',
            termFormsAvailable: [],
            termForms: [],
            termFormFields: {},
            selectedTermForms: [],
            harassmentCertification: undefined,

            timecardFA: timecardFA,
            isFinalApproverByTier: isFinalApproverByTier,

            // New Batch
            newBatch: {
                name: '',
                week_ending: '',
                description: '',
                department_id: '',
                signatory_name: '',
                is_union: '',
                status: 1,
            },
            editBatch: {
                id: '',
                name: '',
                week_ending: '',
                description: '',
                department_id: '',
                signatory_name: '',
                is_union: '',
                status: ''
            },
            allSignatories: [],
            isDisabled: false,
            defaultSignatories: [],
            selectedBatch: {
                week_ending: '',
                description: '',
                signatory_name: '',
                union: '',
                department: '',
            },
            rowHashData: new Map(),
            rowData: [],
            iteration:0,
            gridOptions: {
                singleClickEdit: true,
                enterMovesDown: true,
                stopEditingWhenGridLosesFocus: true,
                enterMovesDownAfterEdit: true,
                alwaysShowHorizontalScroll: true,
                enableRangeSelection: true,
                defaultColDef: {
                    resizable: true,
                    suppressMiniFilter: false,
                },
                rowSelection: 'multiple',
                // editType: 'fullRow',
                onGridReady: (event) => this.$refs['selectedTimecardGrid'].onGridReady(event),
                // onRowValueChanged: (event) => this.isGridChanged(event),
            },
            getRowStyle: params => {
                return params.data.isMatched ? null : {'background-color': '#D3D3D3'};
            },
            columnDefs: [
                {
                    field: 'selected',
                    cellRenderer: (params) => {
                        let input = document.createElement('input')
                        input.type = 'checkbox'
                        input.checked = params.data.selected > 0 ? true : false
                        input.disabled = params.data.isMatched > 0 ? false : true
                        input.addEventListener('change', (event) => {
                            params.data.selected = event.target.checked ? 1 : 0
                        })
                        return input
                    },
                    minWidth: 50,
                    maxWidth: 80,
                    headerName: 'Select',
                    sortable: true,
                    sort: 'desc',
                    initialSortIndex: 1,
                    valueGetter: (params) => params.data.selected,
                },
                {
                    field: 'status',
                    sortable: true,
                    minWidth: 50,
                    maxWidth: 200,
                    headerName: 'Status',
                    valueGetter: (params) => params.data.status,
                },
                {
                    field: 'week_ending',
                    sortable: true,
                    headerName: 'WeekEnding',
                    minWidth: 50,
                    maxWidth: 150,
                    valueGetter: (params) => params.data.week_ending,
                    valueFormatter: (params) => {
                        if (!params || !params.value) return;
                        return params.data.week_ending.split('T')[0];
                    },
                },
                {
                    field: 'employee',
                    sortable: true,
                    headerName: 'Name',
                    minWidth: 50,
                    maxWidth: 200,
                    valueGetter: (params) => params.data.employee,
                },
                {
                    field: 'union_local',
                    sortable: true,
                    headerName: 'Union',
                    minWidth: 50,
                    maxWidth: 200,
                    valueGetter: (params) => params.data.union_local ? params.data.union_local : 'Non Union',
                },
                {
                    field: 'department',
                    sortable: true,
                    headerName: 'Department',
                    minWidth: 50,
                    maxWidth: 200,
                    valueGetter: (params) => params.data.department ? params.data.department : 'No Department',
                },
                {
                    field: 'signatory_name',
                    sortable: true,
                    headerName: 'Signatory',
                    minWidth: 50,
                    maxWidth: 200,
                    valueGetter: (params) => params.data.signatory_name,
                },
            ],
            editBatchModal: false,
            isBatchChanged: false,
        }
    },

    computed: {
        disabled() {
            let days;
            const weekEndingDay = this.entity.week_ending;
            switch (weekEndingDay) {
                case 'Sunday':
                    days = [1, 2, 3, 4, 5, 6];
                    break;

                case 'Monday':
                    days = [0, 2, 3, 4, 5, 6];
                    break;

                case 'Tuesday':
                    days = [0, 1, 3, 4, 5, 6];
                    break;

                case 'Wednesday':
                    days = [0, 1, 2, 4, 5, 6];
                    break;

                case 'Thursday':
                    days = [0, 1, 2, 3, 5, 6];
                    break;

                case 'Friday':
                    days = [0, 1, 2, 3, 4, 6];
                    break;

                default:
                    days = [0, 1, 2, 3, 4, 5];
            }

            return days;
        },
        width() {
            // Reducing by 3 % to handle sigma-frontend navbar
            return '100%';
        },

        height() {
            // Reducing by 3 % to handle sigma-frontend navbar
            return window.innerHeight * 0.32 + 'px';
        },

        today() {
            let date = new Date();
            var day = date.getDate();
            var monthIndex = date.getMonth();
            var year = date.getFullYear();

            return year + '-' + this.pad(monthIndex * 1 + 1) + '-' + this.pad(day);
        },

        unapprovedTimecards() {
            if (!this.timecards || this.timecards === undefined) return undefined
            else if (this.timecards.length === 0) return [];

            // Set search filter criteria
            let tcstatus = (this.statusFilterToApprove) ? new RegExp(this.statusFilterToApprove.replace(/\(|\)|\[|\]/g,'-'), 'i') : ''; // TC status
            let tcreview = this.reviewFilterToApprove || null;
            let show = (this.showFilterToApprove) ? new RegExp(this.showFilterToApprove, 'i') : '';  // Show
            let bat = (this.batchesFilterToApprove === 'none') ? new RegExp('^$') : (this.batchesFilterToApprove) ? new RegExp('^' + this.batchesFilterToApprove.replace(/\(|\)|\[|\]/g,'-') + '$', 'i') : '';
            let dept = (this.departmentFilterToApprove === 'none') ? new RegExp('^$') : (this.departmentFilterToApprove) ? new RegExp(this.departmentFilterToApprove, 'i') : '';  // Department
            let weekEnding = (this.weekFilterToApprove) ? new RegExp(this.weekFilterToApprove.long.substring(0, 10), 'i') : ''; // Week Ending
            let union = (this.unionFilterToApprove === 'union') ? new RegExp(/^[\w]/) : (this.unionFilterToApprove === 'none') ? new RegExp('^$') : (this.unionFilterToApprove) ? new RegExp(this.unionFilterToApprove, 'i') : '';

            this.selectedTimecards = [];
            let selectedRowHashData = new Map();
            const timecards = this.timecards.filter(({ id, hash, agreement_id, employee, union_local_id, department_id, entity, entity_id, department, status, status_full, week_ending, union_local, batch }) => {
                const testResult = entity.match(show) && (department || '').match(dept) && (union_local || '').match(union) && (batch ? batch.replace(/\(|\)|\[|\]/g,'-') : '').match(bat) && status_full.replace(/\(|\)|\[|\]/g,'-').match(tcstatus) && week_ending.match(weekEnding) && parseInt(status) >= 0 && parseInt(status) < 5

                // Test for reviews which are stored separately from timecards
                const currentReview = this.timecardReviews.find((review) => parseInt(review.timecard_id) === parseInt(id));
                let reviewTest;
                if (tcreview && currentReview && currentReview.review_type) {
                    reviewTest = currentReview.review_type === tcreview;
                } else if (tcreview) {
                    reviewTest = false;
                } else { 
                    // If no review status is selected, always true
                    reviewTest = true;
                }

                // Auto select batched timecards
                if (testResult && reviewTest && this.showBatches && bat) {
                    selectedRowHashData.set(hash, {id: id, entity_id: entity_id, agreement_id: agreement_id, hash: hash, status: status_full, week_ending: week_ending, employee: employee, union_local: union_local, union_local_id: union_local_id, department: department, department_id: department_id});
                    this.selectedTimecards.push(hash);
                }
                return testResult && reviewTest;
            });

            this.addRowHashData(selectedRowHashData, true);
            return timecards;
        },

        openTimecards() {
            if (!this.timecardsOpen || this.timecardsOpen === undefined) return undefined
            else if (this.timecardsOpen.length === 0) return [];
            // Set search filter criteria
            let tcstatus = (this.statusFilterNew) ? new RegExp(this.statusFilterNew.replace(/\(|\)|\[|\]/g,'-'), 'i') : ''; // TC status
            let tcreview = this.reviewFilterNew || null;
            let show = (this.showFilterNew) ? new RegExp(this.showFilterNew, 'i') : '';  // Show
            let bat = (this.batchesFilterToOpen === 'none') ? new RegExp('^$') : (this.batchesFilterToOpen) ? new RegExp('^' + this.batchesFilterToOpen.replace(/\(|\)|\[|\]/g,'-') + '$', 'i') : '';
            let dept = (this.departmentFilterNew === 'none') ? new RegExp('^$') : (this.departmentFilterNew) ? new RegExp(this.departmentFilterNew, 'i') : '';  // Department
            let weekEnding = (this.weekFilterNew) ? new RegExp(this.weekFilterNew.long.substring(0, 10), 'i') : ''; // Week Ending
            let union = (this.unionFilterNew === 'union') ? new RegExp(/^[\w]/) : (this.unionFilterNew === 'none') ? new RegExp('^$') : (this.unionFilterNew) ? new RegExp(this.unionFilterNew, 'i') : '';

            setTimeout(function () { $('[data-toggle="tooltip"]').tooltip() }, 250);

            this.selectedOpenTimecards = [];

            const timecards =  this.timecardsOpen.filter(({ id, hash, entity, department, status, status_full, week_ending, union_local, batch }) => {
                const testResult = entity.match(show) && (department || '').match(dept) && (union_local || '').match(union) && (batch ? batch.replace(/\(|\)|\[|\]/g,'-') : '').match(bat) && week_ending.match(weekEnding) && status_full.replace(/\(|\)|\[|\]/g,'-').match(tcstatus) && parseInt(status) < 5

                // Test for reviews which are stored separately from timecards
                const currentReview = this.timecardReviews.find((review) => parseInt(review.timecard_id) === parseInt(id));
                let reviewTest;
                if (tcreview && currentReview && currentReview.review_type) {
                    reviewTest = currentReview.review_type === tcreview;
                } else if (tcreview) {
                    reviewTest = false;
                } else { 
                    // If no review status is selected, always true
                    reviewTest = true;
                }

                // Auto select batched timecards
                if (testResult && reviewTest && this.showBatches && bat) {
                    this.selectedOpenTimecards.push(hash);
                }
                return testResult && reviewTest;
            });
            return timecards;
        },

        approvedTimecards() {
            if (!this.timecardsApproved || this.timecardsApproved === undefined) return undefined
            else if (this.timecardsApproved.length === 0) return [];

            // Set search filter criteria
            let show = (this.showFilterApproved) ? new RegExp(this.showFilterApproved, 'i') : '';  // Show
            let bat = (this.batchesFilterToApproved === 'none') ? new RegExp('^$') : (this.batchesFilterToApproved) ? new RegExp('^' + this.batchesFilterToApproved.replace(/\(|\)|\[|\]/g,'-') + '$', 'i') : '';
            let dept = (this.departmentFilterApproved === 'none') ? new RegExp('^$') : (this.departmentFilterApproved) ? new RegExp(this.departmentFilterApproved, 'i') : '';  // Department
            let weekEnding = (this.weekFilterApproved) ? new RegExp(this.weekFilterApproved.long.substring(0, 10), 'i') : ''; // Week Ending
            let union = (this.unionFilterApproved === 'union') ? new RegExp(/^[\w]/) : (this.unionFilterApproved === 'none') ? new RegExp('^$') : (this.unionFilterApproved) ? new RegExp(this.unionFilterApproved, 'i') : '';

            this.selectedApprovedTimecards = [];

            const timecards = this.timecardsApproved.filter(({ hash, entity, department, week_ending, union_local, batch, payroll_status }) => {
                const testResult = payroll_status < 1 && entity.match(show) && (department || '').match(dept) && (union_local || '').match(union) && (batch ? batch.replace(/\(|\)|\[|\]/g,'-') : '').match(bat) && week_ending.match(weekEnding)
            
                // Auto select batched timecards
                if (testResult && this.showBatches && bat) {
                    this.selectedApprovedTimecards.push(hash);
                }
                return testResult;
            });
            return timecards;
        },

        missingTimecards() {
            if (!this.timecardsMissing || this.timecardsMissing === undefined) return undefined
            else if (this.timecardsMissing.length === 0) return [];

            setTimeout(function () { $('[data-toggle="tooltip"]').tooltip() }, 250);
            return this.timecardsMissing;
        },

        filteredStarts() {
            if (!this.allStarts || this.allStarts.length === 0) return [];

            // Set search filter criteria
            let dept = (this.departmentFilterStarts === 'none') ? new RegExp('^$') : (this.departmentFilterStarts) ? new RegExp(this.departmentFilterStarts, 'i') : '';  // Department
            let union = (this.unionLocalFilterStarts === 'none') ? new RegExp('^$') : (this.unionLocalFilterStarts) ? new RegExp(this.unionLocalFilterStarts, 'i') : '';  // Local
            let stat = (this.statusFilterStarts) ? new RegExp(this.statusFilterStarts, 'i') : ''; // TC status

            const starts = this.allStarts.filter(function ({ department, union_local, status_full }) {
                return ((department || '').match(dept) && (union_local || '').match(union) && (status_full || '').match(stat));
            });

            setTimeout(function () { $('[data-toggle="tooltip"]').tooltip() }, 250);
            if (this.sortMethodStarts === '') {
                return starts
            } else {
                return this.sortObjectByProperty(starts, this.sortMethodStarts)
            }
        },

        filteredNeedingI9Starts() {
            if (!this.allStarts || this.allStarts.length === 0 || !this.needingI9Starts || this.needingI9Starts.length === 0) return [];

            if (this.seeMyDepartmentOnlyI9) {
                // Find intersection of all starts (which is limited in permission) to I9s (which is not limited).
                const limitedIds = new Set(this.allStarts.map((start) => start.id));
                const intersection = this.needingI9Starts.filter((start) => limitedIds.has(start.id));
                return intersection;
            } else {
                return this.needingI9Starts;
            }
        },

        selectAllTimecards: {
            get: function () {
                return this.unapprovedTimecards ? this.selectedTimecards.length == this.unapprovedTimecards.length : false;
            },
            set: function (value) {
                var selected = [];
                let selectedEmails = new Map();
                let selectedRowHashData = new Map();
                let unApprovedSelectedTimecards = new Map();
                if (value) {
                    this.unapprovedTimecards.forEach(function (timecard) {
                        selected.push(timecard.hash);
                        selectedRowHashData.set(timecard.hash, {id: timecard.id, entity_id: timecard.entity_id, agreement_id: timecard.agreement_id, hash: timecard.hash, status: timecard.status_full, week_ending: timecard.week_ending, employee: timecard.employee, union_local: timecard.union_local, union_local_id: timecard.union_local_id, department: timecard.department, department_id: timecard.department_id});
                        if (timecard.assignment_modified > 0 && timecard.assignment_propay_id > 0) {
                            selectedEmails.set(timecard.hash, timecard.assignment_object.hash);
                        }
                        if (!timecard.status_full || timecard.status_full != 'Employer Approved') {
                            unApprovedSelectedTimecards.set(timecard.hash, true);
                        }
                    });
                }
                this.unApprovedSelectedTimecards = unApprovedSelectedTimecards;
                this.selectedTimecards = selected;
                this.selectedTimecardsEmail = selectedEmails;
                this.addRowHashData(selectedRowHashData); // we can't use async function to get a signatory, so we need to do like this.
            }
        },

        selectAllOpenTimecards: {
            get: function () {
                return this.openTimecards ? this.selectedOpenTimecards.length == this.openTimecards.length : false;
            },
            set: function (value) {
                var selected = [];
                let selectedEmails = new Map();

                if (value) {
                    this.openTimecards.forEach(function (timecard) {
                        selected.push(timecard.hash);
                        if (timecard.assignment_modified > 0 && timecard.assignment_propay_id > 0) {
                            selectedEmails.set(timecard.hash, timecard.assignment_object.hash);
                        }
                    });
                }

                this.selectedOpenTimecards = selected;
                this.selectedOpenTimecardsEmail = selectedEmails;
            }
        },

        selectAllApprovedTimecards: {
            get: function () {
                return this.approvedTimecards ? this.selectedApprovedTimecards.length == this.approvedTimecards.length : false;
            },
            set: function (value) {
                var selected = [];
                let selectedEmails = new Map();

                if (value) {
                    this.approvedTimecards.forEach(function (timecard) {
                        selected.push(timecard.hash);
                        if (timecard.assignment_modified > 0 && timecard.assignment_propay_id > 0) {
                            selectedEmails.set(timecard.hash, timecard.assignment_object.hash);
                        }
                    });
                }

                this.selectedApprovedTimecards = selected;
                this.selectedApprovedTimecardsEmail = selectedEmails;
            }
        },

        selectAllSubmittedTimecards: {
            get: function () {
                return this.timecardsSubmitted ? this.selectedSubmittedTimecards.length == this.timecardsSubmitted.length : false;
            },
            set: function (value) {
                var selected = [];
                let selectedEmails = new Map();

                if (value) {
                    this.timecardsSubmitted.forEach(function (timecard) {
                        selected.push(timecard.hash);
                        if (timecard.assignment_modified > 0 && timecard.assignment_propay_id > 0) {
                            selectedEmails.set(timecard.hash, timecard.assignment_object.hash);
                        }
                    });
                }

                this.selectedSubmittedTimecards = selected;
                this.selectedSubmittedTimecardsEmail = selectedEmails;
            }
        },

        selectAllMissingTimecards: {
            get: function () {
                return this.missingTimecards ? this.selectedMissingTimecards.length == this.missingTimecards.length : false;
            },
            set: function (value) {
                var selected = [];

                if (value) {
                    this.missingTimecards.forEach(function (timecard) {
                        selected.push(timecard.hash);
                    });
                }

                this.selectedMissingTimecards = selected;
            }
        },

        selectAllWaitingStarts: {
            get: function () {
                return this.waitingStarts ? this.selectedWaitingStarts.length == this.waitingStarts.length : false;
            },
            set: function (value) {
                var selected = [];

                if (value) {
                    this.waitingStarts.forEach(function (assignment) {
                        selected.push(assignment.hash);
                    });
                }

                this.selectedWaitingStarts = selected;
            }
        },

        selectAllUnsentStarts: {
            get: function () {
                return this.unsentStarts ? this.selectedUnsentStarts.length == this.unsentStarts.length : false;
            },
            set: function (value) {
                var selected = [];

                if (value) {
                    this.unsentStarts.forEach(function (assignment) {
                        selected.push(assignment.hash);
                    });
                }

                this.selectedUnsentStarts = selected;
            }
        },

        selectAllOpenStarts: {
            get: function () {
                return this.openStarts ? this.selectedOpenStarts.length == this.openStarts.length : false;
            },
            set: function (value) {
                var selected = [];

                if (value) {
                    this.openStarts.forEach(function (assignment) {
                        selected.push(assignment.hash);
                    });
                }

                this.selectedOpenStarts = selected;
            }
        },

        selectAllReadyToApproveStarts: {
            get: function () {
                return this.readyToApproveStarts ? this.selectedReadyToApproveStarts.length == this.readyToApproveStarts.length : false;
            },
            set: function (value) {
                var selected = [];

                if (value) {
                    this.readyToApproveStarts.forEach(function (assignment) {
                        selected.push(assignment.hash);
                    });
                }

                this.selectedReadyToApproveStarts = selected;
            }
        },

        selectAllCompletedStarts: {
            get: function () {
                return this.completedStarts ? this.selectedCompletedStarts.length == this.completedStarts.length : false;
            },
            set: function (value) {
                var selected = [];

                if (value) {
                    this.completedStarts.forEach(function (assignment) {
                        selected.push(assignment.hash);
                    });
                }

                this.selectedCompletedStarts = selected;
            }
        },

        selectAllRecentlyCompletedStarts: {
            get: function () {
                return this.recentlyCompletedStarts ? this.selectedRecentlyCompletedStarts.length == this.recentlyCompletedStarts.length : false;
            },
            set: function (value) {
                var selected = [];

                if (value) {
                    this.recentlyCompletedStarts.forEach(function (assignment) {
                        selected.push(assignment.hash);
                    });
                }

                this.selectedRecentlyCompletedStarts = selected;
            }
        },

        selectAllNeedingI9Starts: {
            get: function () {
                return this.needingI9Starts ? this.selectedNeedingI9Starts.length == this.needingI9Starts.length : false;
            },
            set: function (value) {
                var selected = [];

                if (value) {
                    this.needingI9Starts.forEach(function (assignment) {
                        selected.push(assignment.hash);
                    });
                }

                this.selectedNeedingI9Starts = selected;
            }
        },

        selectAllStarts: {
            get: function () {
                return this.allStarts ? this.selectedAllStarts.length == this.allStarts.length : false;
            },
            set: function (value) {
                var selected = [];

                if (value) {
                    this.allStarts.forEach(function (assignment) {
                        selected.push(assignment.hash);
                    });
                }

                this.selectedAllStarts = selected;
            }
        },

        selectAllTerminatedStarts: {
            get: function () {
                return this.terminatedStarts ? this.selectedTerminatedStarts.length == this.terminatedStarts.length : false;
            },
            set: function (value) {
                var selected = [];

                if (value) {
                    this.terminatedStarts.forEach(function (assignment) {
                        selected.push(assignment.hash);
                    });
                }

                this.selectedTerminatedStarts = selected;
            }
        },

        selectAllCertifications: {
            get: function () {
                return this.certifiedEmployees ? this.selectedCertifications.length == this.certifiedEmployees.length : false;
            },
            set: function (value) {
                var selected = [];

                if (value) {
                    this.certifiedEmployees.forEach(function (assignment) {
                        selected.push(assignment.hash);
                    });
                }

                this.selectedCertifications = selected;
            }
        },

        selectAllEdits: {
            get: function () {
                return this.edits ? this.selectedEdits.length == this.edits.length : false;
            },
            set: function (value) {
                var selected = [];

                if (value) {
                    this.edits.forEach((edit) => {
                        selected.push(edit.id);
                    });
                }

                this.selectedEdits = selected;
            }
        },

        selectAllFilteredStarts: {
            get: function () {
                return this.filteredStarts ? this.selectedFilteredStarts.length == this.filteredStarts.length : false;
            },
            set: function (value) {
                var selected = [];

                if (value) {
                    this.filteredStarts.forEach((assignment) => {
                        selected.push(assignment.hash);
                    });
                }

                this.selectedFilteredStarts = selected;
            }
        },

        timecardsToApproveSorted() {
            let timecards;
            if (this.tcSortMethodToApprove === '') {
                timecards = this.unapprovedTimecards
            } else {
                const sorted = this.sortObjectByProperty(this.unapprovedTimecards, this.tcSortMethodToApprove)
                timecards = sorted;
            }

            // Every time todo is updated, stort the sort order/filters
            const tcHashes = ((timecards || []) && timecards.length) ? timecards.map((tc) => tc.hash || null) : [];
            localStorage.setItem('timecardList', JSON.stringify(tcHashes));
            return timecards;
        },

        timecardsOpenSorted() {
            if (this.tcSortMethodOpen === '') {
                return this.openTimecards
            } else {
                return this.sortObjectByProperty(this.openTimecards, this.tcSortMethodOpen)
            }
        },

        timecardsApprovedSorted() {
            if (this.tcSortMethodApproved === '') {
                return this.timecardsApproved
            } else {
                return this.sortObjectByProperty(this.timecardsApproved, this.tcSortMethodApproved)
            }
        },

        // Deprecated
        timecardsSearchSorted() {
            if (this.tcSortMethodSearch === '') {
                return this.searchTimecards
            } else {
                return this.sortObjectByProperty(this.searchTimecards, this.tcSortMethodSearch)
            }
        },

        openBatches() {
            if (!this.batches || !Array.isArray(this.batches) || this.batches.length === 0) {
                return [];
            } else {
                return this.batches.filter(({ id, status }) => parseInt(status) === 1)
            }
        },

        allInBatchSelected() {
            if (!this.showBatches) return true;

            if ( (this.batchesFilterToApprove && this.selectAllTimecards === true) || (this.batchesFilterToOpen && this.selectAllOpenTimecards === true) ) {
                return true;
            } else {
                return false;
            }
        },

        uncertifiedEmployees() {
            if (!this.certifiedEmployees || this.certifiedEmployees.length === 0) return 0;
            const emps = this.certifiedEmployees.filter(({ certifications }) => certifications.length === 0)
            return emps.length || 0;
        },

        filteredCertifications() {
            if (!this.certifiedEmployees || this.certifiedEmployees.length === 0) return [];
            // Set search filter criteria
            let certified = this.certifiedStatus;
            let supervisor = this.certifiedSupervisor;

            setTimeout(function () { $('[data-toggle="tooltip"]').tooltip() }, 250);
            return this.certifiedEmployees.filter(({ is_supervisor, certifications, certication_type_id }) => {
                const isCertified = (certified === '' || certified === undefined) || (certified ? certifications.length > 0 : certifications.length === 0);
                const isSupervisor = (supervisor === '' || supervisor === undefined) || (supervisor ? is_supervisor : !is_supervisor);
                return isCertified && isSupervisor;
            });
        },

        isArchived() {
            if (!this.entity) return false;
            return parseInt(this.entity.status) === 0;
        }
    },

    methods: {
        autoGenerateNewBatchName() {
            let autoName = ''
            if (this.newBatch.week_ending) {
                if (this.newBatch.week_ending instanceof Date) {
                    let temp = DateTime.fromJSDate(this.newBatch.week_ending).toFormat(this.format).replace(/[ \.\,\/-]/g, '-');
                    autoName = temp;
                }
                else {
                    autoName = String(this.newBatch.week_ending).replace(/[ \.\,\/-]/g, '-');
                }
            }
            if (this.newBatch.is_union === '1') autoName += ' Union';
            else if (this.newBatch.is_union === '0') autoName += ' Non Union';
        
            if (this.newBatch.department_id) {
                let deptName = this.departments.find((dept) => dept.id == this.newBatch.department_id);
                if (deptName) autoName += ` ${deptName.name}`;
            }
            if (this.newBatch.signatory_name) autoName += ` ${this.newBatch.signatory_name}`;
            let addNum = autoName;
            // to generate auto-name. If there is same name, will be added _1, _2, _3 ...
            for(let count=1;count <= this.batches.length+1;count++) {
                let findIdx = this.batches.findIndex(bat => bat.name == addNum);
                if (findIdx == -1) {
                    autoName = addNum;
                    break;
                }
                addNum = autoName + '_' + count;
            }
            this.newBatch.name = autoName;
        },
        async openEditBatchModal() {
            let response = await this.oasisApi.get(`/batches?name=${this.batchesFilterToApprove}`);
            if (response && response.data && response.data.results.length > 0) {
                this.editBatch.id = response.data.results[0].id; // requried field
                this.editBatch.name = response.data.results[0].name; // requried field
                this.editBatch.description = response.data.results[0].description ? response.data.results[0].description : '';
                this.editBatch.week_ending = this.parseLuxon(response.data.results[0].week_ending).toFormat(this.format); // requried field
                this.editBatch.department_id = response.data.results[0].department_id ? response.data.results[0].department_id : '';
                this.editBatch.union_local_id = response.data.results[0].union_local_id ? response.data.results[0].union_local_id : '';
                this.editBatch.status = response.data.results[0].status;
                this.editBatch.is_union = response.data.results[0].is_union == 1 ? true : false;
                this.editBatch.signatory_name = response.data.results[0].signatory_name ? response.data.results[0].signatory_name : '';
            }
            this.editBatchModal = true;
        },
        async getBatchInfo(batchId) {
            let response = await this.oasisApi.get(`/batches/${batchId}`);
            let batchInfo = response.data;
            this.selectedBatch.union = batchInfo.results[0].is_union == 1 ? 'Union' : 'Non Union';
            this.selectedBatch.description = batchInfo.results[0].description ? batchInfo.results[0].description : '';
            this.selectedBatch.week_ending = batchInfo.results[0].week_ending ? batchInfo.results[0].week_ending : '';
            this.selectedBatch.department = batchInfo.results[0].department ? batchInfo.results[0].department : '';
            this.selectedBatch.signatory_name = batchInfo.results[0].signatory_name ? batchInfo.results[0].signatory_name : '';
            if (response && batchInfo) {
                for (let row of this.rowData) {
                    let wasChanged = false;
                    row.isMatched = false;
                    row.selected = false;
                    // check whether department_id was changed or not
                    let batDept = batchInfo.results[0].department_id ? batchInfo.results[0].department_id : null;
                    let assDept = row.department_id ? row.department_id : null;
                    if (batDept && (batDept != assDept)) {
                        wasChanged = true;
                        continue;   
                    }
                    // check whether week_ending was changed or not
                    if (!wasChanged && row.week_ending.split('T')[0] != batchInfo.results[0].week_ending.split('T')[0]) {
                        wasChanged = true;
                        continue;
                    }
                    // union check
                    if (!wasChanged) {
                        let batUnion = batchInfo.results[0].is_union == 1 ? true : false;
                        let assUnion = row.union_local_id ? true : false;
                        if (batUnion != assUnion) {
                            wasChanged = true;
                            continue;
                        }
                    }

                    //signatory check
                    if (!wasChanged) {
                        let assSig = row.signatory_name ? row.signatory_name : null;
                        let batSig = batchInfo.results[0].signatory_name ? batchInfo.results[0].signatory_name : null;
                        if (assSig != batSig) {
                            wasChanged = true;
                            continue;
                        }
                    }
                    row.isMatched = true;
                    row.selected = true;
                }
            }
            this.gridOptions.api.redrawRows()
        },
        // this is for computed function... - "selectAllTimecards"
        async addRowHashData(selectedHash, canUseSameSig = false) {
            // If canUseSameSig is true, It is came from filtered data by batch. which mean is that all filtered batches have same signatory. so we don't need api call on each timecards
            this.rowHashData = new Map();
            let getSignatory;
            for(const [key, value] of selectedHash.entries()) {
                if (!canUseSameSig || !getSignatory) getSignatory = await this.getSignatory(value.entity_id, value.union_local_id, value.agreement_id);
                this.rowHashData.set(key, {id: value.id, selected: false, hash: value.hash, status: value.status, week_ending: value.week_ending, employee: value.employee, union_local: value.union_local, union_local_id: value.union_local_id, department: value.department, department_id: value.department_id, signatory_name: getSignatory, isMatch:false});
            }
        },
        async getSignatory(entityId = null, unionLocalId = null, agreementId = null) {
            if (!entityId) return null;
            let url = `/signatory/${entityId}/${unionLocalId}/${agreementId}`;
            const response = await this.oasisApi.get(url);
            if (response.status == 200 && response.data) {
                // normal case
                return response.data;
            } else {
                // this case will be really really rare case. we consider only one case that our server is down. but If our server down, other api calls will not be ran as well, so added just in case to avoid to be blocked.
                return this.entity.name;
            }
        },
        async openBatchModal() {
            let selectionChanged = false;
            if ((this.rowData.length != this.rowHashData.size) && this.move_batch.id) selectionChanged = true; // this case is for being selection changed in dashboard by user after modal closed, so we need to validate again.
            this.rowData = [];
            for(const [key, value] of this.rowHashData.entries()) {
                this.rowData.push(value);
            }
            if (selectionChanged) await this.getBatchInfo(this.move_batch.id);
            this.batchModal = true;
        },
        async checkAssignmentModified(timecard, type) {
            // when we select checkbox, we need more data to use export propay function later.
            if (type == 'selectedTimecards') {
                if (!timecard.status_full || timecard.status_full != 'Employer Approved') {
                    if (!this.unApprovedSelectedTimecards.has(timecard.hash)) {
                        // add unapproved timecard hash when user select checkbox
                        this.unApprovedSelectedTimecards.set(timecard.hash,true);
                    } else {
                        // remove timecard hash when user deselect checkbox.
                        this.unApprovedSelectedTimecards.delete(timecard.hash);
                    }
                }
                //console.log("timecard : "  + JSON.stringify(timecard,null,2))
                if (this.rowHashData.has(timecard.hash)) {
                    this.rowHashData.delete(timecard.hash);
                } else {
                    let getSignatory = await this.getSignatory(timecard.entity_id, timecard.union_local_id, timecard.agreement_id)
                    this.rowHashData.set(timecard.hash, {id: timecard.id, selected: false, hash: timecard.hash, status: timecard.status_full, week_ending: timecard.week_ending, employee: timecard.employee, union_local: timecard.union_local, union_local_id: timecard.union_local_id, department: timecard.department, department_id: timecard.department_id, signatory_name: getSignatory, isMatch:false});
                }
                if (timecard.assignment_modified > 0 && timecard.assignment_propay_id > 0) {
                    if (this.selectedTimecardsEmail.has(timecard.hash)) {
                        // de-select case
                        this.selectedTimecardsEmail.delete(timecard.hash);
                    } else {
                        // select case
                        this.selectedTimecardsEmail.set(timecard.hash, timecard.assignment_object.hash);
                    }
                }
            } else if (type == 'selectedOpenTimecards') {
                if (timecard.assignment_modified > 0 && timecard.assignment_propay_id > 0) {
                    if (this.selectedOpenTimecardsEmail.has(timecard.hash)) {
                        this.selectedOpenTimecardsEmail.delete(timecard.hash);
                    } else {
                        this.selectedOpenTimecardsEmail.set(timecard.hash, timecard.assignment_object.hash);
                    }
                }
            } else if (type == 'selectedApprovedTimecards') {
                if (timecard.assignment_modified > 0 && timecard.assignment_propay_id > 0) {
                    if (this.selectedApprovedTimecardsEmail.has(timecard.hash)) {
                        this.selectedApprovedTimecardsEmail.delete(timecard.hash);
                    } else {
                        this.selectedApprovedTimecardsEmail.set(timecard.hash, timecard.assignment_object.hash);
                    }
                }
            } else if (type == 'selectedSubmittedTimecards') {
                if (timecard.assignment_modified > 0 && timecard.assignment_propay_id > 0) {
                    if (this.selectedSubmittedTimecardsEmail.has(timecard.hash)) {
                        this.selectedSubmittedTimecardsEmail.delete(timecard.hash);
                    } else {
                        this.selectedSubmittedTimecardsEmail.set(timecard.hash, timecard.assignment_object.hash);
                    }
                }
            }
        },
        pushArray(data, array, sort) {
            array.pushUnique(data, sort);
            return data;
        },

        addDate(date, array) {
            let newDate = this.convertDate(date);
            array.pushUniqueDate({ "short": newDate, "long": date });
            return newDate;
        },

        // Takes a date and returns in YYYY-mm-dd format
        convertDate(date) {
            if (!date) return false;

            let newDate = new Date(date);
            if (this.locale === 'en-CA') { 
                newDate = newDate.toLocaleDateString('en-GB', {
                    year: 'numeric',
                    day: '2-digit',
                    month: '2-digit',
                });
            } else {
                newDate = newDate.toLocaleDateString(this.locale, {
                    year: 'numeric',
                    day: '2-digit',
                    month: '2-digit',
                });
            }
            return newDate;
        },

        getDaysWorked(timecard) {
            let days = 0
            if (!timecard) return days;
            days += (timecard.broken_object && (timecard.broken_object.week || {}).daysWorked) || 0;
            days += (timecard.broken_object2 && (timecard.broken_object2.week || {}).daysWorked) || 0;
            return days;
        },

        getOT(timecard) {
            // Always show 0 for exempt
            if (parseInt(timecard.assignment_object.flsa_type_id) === 2) {
                return 0;
            }
            const totalHours = parseFloat(timecard.total_hours) ;
            const daysWorked = parseFloat((((timecard.broken_object || {}).week || {}).daysWorked) || 0) + parseFloat((((timecard.broken_object2 || {}).week || {}).daysWorked) || 0);
            const guaranteedHours = parseFloat(timecard.assignment_object.guaranteed_hours || 8);
            const guaranteedWeeklyHours = parseInt(timecard.assignment_object.guaranteed_hours_unit_id) === 8 ? (daysWorked * guaranteedHours) : guaranteedHours;
            const actualOT = (timecard.total_ot && parseInt(timecard.assignment_object.flsa_type_id) !== 2) ? (parseFloat(timecard.total_hours) - parseFloat(((((timecard.broken_object || {}).week || {}).pay_straight || {}).hours) || 0) - parseFloat(((((timecard.broken_object2 || {}).week || {}).pay_straight || {}).hours) || 0)) : 0;
            let warning = false;
            if (totalHours - guaranteedWeeklyHours > 0) {
                warning = true;
            }
            return { value: actualOT.formatNumber(), warning: warning };
        },

        getPenalties(timecard) {
            let penalty = parseFloat(((((timecard.broken_object || {}).week || {}).penalties || {}).pay) || 0) + parseFloat(((((timecard.broken_object2 || {}).week || {}).penalties || {}).pay) || 0)
            if (penalty && penalty > 0) {
                return `<a>${penalty.formatNumber('$')}</a>`;
            } else {
                return 0;
            }
        },

        getComments(timecard) {
            let ee = '',
                er = '',
                pr = '';

            if (timecard.employee_comments) ee = "Main:" + timecard.employee_comments + "<br />";
            if (timecard.employer_comments) er = "Main:" + timecard.employer_comments + "<br />";
            if (timecard.payroll_comments) pr = "Main:" + timecard.payroll_comments + "<br />";

            for (let i in timecard.timecard_object) {
                if (!timecard.timecard_object[i] || typeof timecard.timecard_object[i] !== 'object') continue;
                if (timecard.timecard_object[i].hasOwnProperty('employee_comments')) {
                    ee += timecard.timecard_object[i].date.short + ": " + timecard.timecard_object[i].employee_comments + "<br />";
                }
                if (timecard.timecard_object[i].hasOwnProperty('employer_comments')) {
                    er += timecard.timecard_object[i].date.short + ": " + timecard.timecard_object[i].employer_comments + "<br />";
                }
            }

            if (ee || er || pr) {
                ee = ee ? '<strong>EMPLOYEE COMMENTS</strong>:<br />' + ee.replace(/\"/g, "") + '<hr />' : '';
                er = er ? '<strong>EMPLOYER COMMENTS</strong>:<br />' + er.replace(/\"/g, "") + '<hr />' : '';
                pr = pr ? '<strong>PAYROLL COMMENTS</strong>:<br />' + pr.replace(/\"/g, "") : '';
                return `<a data-toggle="tooltip" data-placement="left" data-html="true" title="${ee}${er}${pr}">View</a>`;
            } else {
                return '';
            }
        },

        getReviews(timecard) {
            const latestReview = this.timecardReviews.find((review) => review.timecard_id === timecard.id)
            if (latestReview) {
                if (this.unapprovedTimecards.find((tc) => tc.id === timecard.id)) this.pushArray(latestReview.review_type, this.reviewsToApprove);
                if (this.openTimecards.find((tc) => tc.id === timecard.id)) this.pushArray(latestReview.review_type, this.reviewsNew);
                return `<a data-toggle="tooltip" data-placement="left" data-html="true" title="${latestReview.comments || 'No comments'}">${latestReview.review_type}</a>`;
            } else {
                return '';
            }
        },

        getStartComments(start) {
            let ee = (start.employee_comments) ? '<strong>EMPLOYEE COMMENTS</strong>:<br />' + start.employee_comments.replace(/\"/g, '') + '<br /><hr />' : '';
            let er = (start.employer_comments) ? '<strong>EMPLOYER COMMENTS</strong>:<br />' + start.employer_comments.replace(/\"/g, '') + '<br />' : '';

            if (ee || er) {
                return `<a data-toggle="tooltip" data-placement="left" data-html="true" title="${ee}${er}">View</a>`;
            }
        },

        buildCommentsLink(params) {
            return params.value ? `<a href="/oasis/timecard/create/${params.data.hash}" target="_blank" data-toggle="tooltip" data-placement="left" data-html="true" title="${params.value}">View</a>` : '';
        },

        approve(selected) {
            if (!selected) { selected = this.selectedTimecards; }
            if (selected.length === 0 && typeof selected !== 'function') {
                this.createDialog({ "title": "Error", "body": 'Please select at least one timecard to approve', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }
            if (typeof selected === 'function') selected = selected();

            // SSR variable
            let approvalOptions = {};
            if (typeof timecardFA === 'undefined' || !timecardFA) {
                approvalOptions.button3 = false;
                approvalOptions.buttonYesLabel = 'Approve';
                approvalOptions.body = 'Once Approved, the selected timecard(s) will go to the next Approver in your organization (if any).';
            } else if (timecardFA === true) {
                approvalOptions.button3 = true;
                approvalOptions.buttonYesLabel = 'Normal Approval';
                approvalOptions.body = 'With &ldquo;Normal Approval,&rdquo; the selected timecard(s) will go to the next Approver in your organization (if any). To bypass any further approvals, please select &ldquo;Give Final Approval.&rdquo;';
            }

            this.createDialog({
                "title": "Please Confirm",
                "body": approvalOptions.body,
                "buttonNo": true, "buttonNoLabel": "Go Back",
                "buttonYesLabel": approvalOptions.buttonYesLabel, "buttonYesAction": function () { app.approveApi({ "final": false }, selected); },
                "button3": approvalOptions.button3, "button3Label": "Give Final Approval", "button3Action": function () { app.approveApi({ "final": true }, selected); }
            });

        },

        submit(selected) {
            if (!selected) { selected = this.selectedTimecards; }
            if (selected.length === 0 && typeof selected !== 'function') {
                this.createDialog({ "title": "Error", "body": 'Please select at least one timecard to submit', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }
            if (typeof selected === 'function') selected = selected();

            if (this.showBatches && this.allInBatchSelected === false) {
                this.createDialog({ "title": "Error", "body": 'To submit, a batch must be chosen AND all timecards in that batch must be selected.  If you do not wish to submit certain timecards in this batch, please move them to another one.', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }

            this.createDialog({
                "title": "Please Confirm",
                "body": "Once submitted, timecards will be processed by Revolution Payroll.",
                "buttonNo": true, "buttonNoLabel": "Go Back",
                "buttonYesLabel": "Submit", "buttonYesAction": function () { app.submitApi(selected); }
            });
        },

        voidTimecards(selected) {
            if (!selected) selected = this.selectedTimecards;
            if (selected.length === 0 && typeof selected !== 'function') {
                this.createDialog({ "title": "Error", "body": 'Please select at least one timecard to void', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }
            if (typeof selected === 'function') selected = selected();

            this.createDialog({
                "title": "Please Confirm",
                "body": 'Once Voided, the selected timecard(s) will no longer be paid.',
                "buttonNo": true, "buttonNoLabel": "Go Back",
                "buttonYesLabel": "Continue", "buttonYesAction": function () { app.changeApi('void', selected); }
            });
        },

        terminateStarts(selected) {
            if (!selected) selected = this.selectedStarts;
            if (selected.length === 0 && typeof selected !== 'function') {
                this.createDialog({ "title": "Error", "body": 'Please select at least one Start to Terminate', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }
            if (typeof selected === 'function') selected = selected();

            this.createDialog({
                "title": "Please Confirm",
                "body": 'Once Terminated, future (s) will no longer be paid for this Show/Job.',
                "buttonNo": true, "buttonNoLabel": "Go Back",
                "buttonYesLabel": "Continue", "buttonYesAction": function () { app.changeApi('terminateStart', selected); }
            });
        },

        processTimecards(selected) {
            if (!selected) selected = this.selectedTimecards;
            if (selected.length === 0 && typeof selected !== 'function') {
                this.createDialog({ "title": "Error", "body": 'Please select at least one timecard to process.', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }
            if (typeof selected === 'function') selected = selected();

            this.createDialog({
                "title": "Please Confirm",
                "body": 'Mark these cards as "Payroll Processed."',
                "buttonNo": true, "buttonNoLabel": "Go Back",
                "buttonYesLabel": "Continue", "buttonYesAction": function () { app.changeApi('process', selected); }
            });

        },

        updateTimecardAssignment(selected) {
            if (!selected) selected = this.selectedTimecards;
            if (selected.length === 0 && typeof selected !== 'function') {
                this.createDialog({ "title": "Error", "body": 'Please select at least one timecard to update.', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }
            if (typeof selected === 'function') selected = selected();

            this.createDialog({
                "title": "Please Confirm",
                "body": 'This will update selected Timecards with the current Start data.',
                "buttonNo": true, "buttonNoLabel": "Go Back",
                "buttonYesLabel": "Continue", "buttonYesAction": function () { app.changeApi('updateTimecardAssignment', selected); }
            });
        },

        recalcTimecards(selected) {
            if (!selected) selected = this.selectedTimecards;
            if (selected.length === 0 && typeof selected !== 'function') {
                this.createDialog({ "title": "Error", "body": 'Please select at least one timecard to recalc.', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }
            if (typeof selected === 'function') selected = selected();

            this.createDialog({
                "title": "Please Confirm",
                "body": 'This will re-calculate selected Timecards.',
                "buttonNo": true, "buttonNoLabel": "Go Back",
                "buttonYesLabel": "Continue", "buttonYesAction": function () { app.changeApi('recalcTimecards', selected); }
            });
        },

        approveApi(options, selected) {
            if (!selected) selected = this.selectedTimecards;
            if (typeof selected === 'function') selected = selected();
            let data = {
                // employee: this.employee,
                timecards: selected,
            };

            if (options && options.final) {
                data.finalApproval = true;
            } else {
                data.finalApproval = false;
            }

            this.waiting = true;

            this.oasisApi.patch('/approve/timecard', data)
                .then(response => {
                    // console.log (response);
                    if (response.status == 200) {
                        if (response.data && response.data.showSubmitMessage) {
                            this.createDialog({ "title": "Success", "body": 'Timecard(s) Approved Successfully<br>Would you like to submit the timecard(s) to be processed by Revolution Payroll?', "buttonNoLabel": "No, I will submit later", "buttonNoAction": function () { location.reload() }, "buttonYesLabel": "Yes, Submit for Processing", "buttonYesAction": function () { app.submitApi(selected)} });
                        } else {
                            this.createDialog({ "title": "Success", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK", "buttonYesAction": function () { location.reload() } });
                            // Remove from toApprove list
                            if (this.timecards && response.data.ids && Array.isArray(response.data.ids)) {
                                for (let i = 0; i <= response.data.ids.length; i++) {
                                    let hash = response.data.ids[i];
                                    if (hash) {
                                        let index = this.timecards.findIndex((el) => { return el.hash == hash });
                                        // console.log (index, hash);
                                        this.timecards.splice(index, 1);
                                    }
                                }
                            }
                        }
                    } else if (response.status == 400) {
                        if (Array.isArray(response.data)) {
                            let message = '';
                            for (let i = 0; i < response.data.length; i++) {
                                let error = JSON.parse(response.data[i]);
                                $("input[name='" + error.field + "']").addClass('form-error2');
                                message += error.message + "\n";
                            }
                            this.createDialog({ "title": "Error", "body": message, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else if (response.data.message) {
                            this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else {
                            this.createDialog({ "title": "Error", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                        }
                    } else {
                        this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                    }
                    this.waiting = false;
                })
                .catch(error => {
                    console.log('error: '); console.log(error); alert(error);
                    this.waiting = false;
                })
                ;

        },

        submitApi(selected) {
            if (!selected) selected = this.selectedTimecards;
            if (typeof selected === 'function') selected = selected();
            let data = {
                // employee: this.employee,
                timecards: selected,
            };

            this.waiting = true;

            this.oasisApi.patch('/approve/timecard/payroll', data)
                .then(response => {
                    // console.log (response);
                    if (response.status == 200) {
                        this.createDialog({ "title": "Success", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK", "buttonYesAction": function () { location.reload() } });
                        // Remove from toApprove list
                        if (this.timecards && response.data.ids && Array.isArray(response.data.ids)) {
                            for (let i = 0; i <= response.data.ids.length; i++) {
                                let hash = response.data.ids[i];
                                if (hash) {
                                    let index = this.timecards.findIndex((el) => { return el.hash == hash });
                                    // console.log (index, hash);
                                    this.timecards.splice(index, 1);
                                }
                            }
                        }

                    } else if (response.status == 400) {
                        if (Array.isArray(response.data)) {
                            let message = '';
                            for (let i = 0; i < response.data.length; i++) {
                                let error = JSON.parse(response.data[i]);
                                $("input[name='" + error.field + "']").addClass('form-error2');
                                message += error.message + "\n";
                            }
                            this.createDialog({ "title": "Error", "body": message, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else if (response.data.message) {
                            this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else {
                            this.createDialog({ "title": "Error", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                        }
                    } else {
                        this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                    }
                    this.waiting = false;
                })
                .catch(error => {
                    console.log('error: '); console.log(error); alert(error);
                    this.waiting = false;
                });

        },

        changeApi(type, selected) {
            if (!type || !selected) return false;
            if (typeof selected === 'function') selected = selected();

            let data = {};
            let apiEndpoint;
            if (type === 'void') {
                data.timecards = selected;
                apiEndpoint = '/bulkchange/timecard/void';
            } else if (type === 'unfinalize') {
                data.timecards = selected;
                apiEndpoint = '/bulkchange/timecard/unfinalize';
            } else if (type === 'returnToEmployer') {
                data.timecards = selected;
                apiEndpoint = '/bulkchange/timecard/returnToEmployer';
            } else if (type === 'process') {
                data.timecards = selected;
                apiEndpoint = '/bulkchange/timecard/process';
            } else if (type === 'updateTimecardAssignment') {
                data.timecards = selected;
                apiEndpoint = '/bulkchange/timecard/refreshAssignment';
            } else if (type === 'recalcTimecards') {
                data.timecards = selected;
                apiEndpoint = '/bulkchange/timecard/recalc';
            } else if (type === 'changebatch') {
                data.timecards = selected;
                data.batch_id = this.move_batch.id;
                apiEndpoint = '/bulkchange/timecard/changebatch';
            } else if (type === 'terminateStart') {
                data.starts = selected;
                data.term_date = this.termDate;
                data.message = this.terminationMessage;
                data.termForms = this.selectedTermForms;
                data.termFormFields = this.termFormFields;
                apiEndpoint = '/bulkchange/start/terminate';
            } else {
                return false;
            }

            this.waiting = true;

            this.oasisApi.patch(apiEndpoint, data)
                .then(response => {
                    // console.log (response);
                    if (response.status == 200) {
                        this.createDialog({ "title": "Success", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                        // Remove from toApprove list
                        if (this.timecards && response.data.ids && Array.isArray(response.data.ids)) {
                            for (let i = 0; i <= response.data.ids.length; i++) {
                                let hash = response.data.ids[i];
                                if (hash) {
                                    let index = this.timecards.findIndex((el) => { return el.hash == hash });
                                    // console.log (index, hash);
                                    if (type !== 'changebatch') {
                                        this.timecards.splice(index, 1);
                                    }
                                }
                            }
                        }

                    } else if (response.status == 400) {
                        if (Array.isArray(response.data)) {
                            let message = '';
                            for (let i = 0; i < response.data.length; i++) {
                                let error = JSON.parse(response.data[i]);
                                $("input[name='" + error.field + "']").addClass('form-error2');
                                message += error.message + "\n";
                            }
                            this.createDialog({ "title": "Error", "body": message, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else if (response.data.message) {
                            this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else {
                            this.createDialog({ "title": "Error", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                        }
                    } else {
                        this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                    }
                    this.waiting = false;
                })
                .catch(error => {
                    console.log('error: '); console.log(error); alert(error);
                    this.waiting = false;
                })
                ;

        },

        reportPayrollStarts(selected) {
            if (!selected || (selected.length === 0 && typeof selected !== 'function')) {
                this.createDialog({ "title": "Error", "body": 'Please select at least one start to report on', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }
            if (typeof selected === 'function') selected = selected();

            this.waiting = true;

            let data = {
                "hashes": selected
            };

            this.oasisApi.post('/reportPayrollStarts', data)
                .then(response => {
                    // console.log (response);
                    if (response.status == 200) {
                        this.createDialog({ "title": "Success", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });

                    } else if (response.status == 400) {
                        if (response.data.message) {
                            this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else {
                            this.createDialog({ "title": "Error", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                        }
                    } else {
                        this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                    }
                    this.waiting = false;
                })
                .catch(error => { console.log('error: '); console.log(error); this.waiting = false; });
        },

        mapTimecards(timecards = null) {
            if (!timecards || !Array.isArray(timecards)) return false;

            let map = {
                shows: [],
                departments: [],
                unions: [],
                statuses: [],
                employees: [],
                weekEndings: [],
            };

            timecards.map(tc => {
                this.pushArray(tc.entity, map.shows)
                if (tc.department) this.pushArray(tc.department, map.departments)
                if (tc.union_local) this.pushArray(tc.union_local, map.unions)
                this.pushArray(tc.status_full, map.statuses);
                this.pushArray(tc.employee, map.employees, true)
                this.addDate(tc.week_ending, map.weekEndings);
            })

            return map;
        },

        createNewTimecard(hash) {
            if (!hash) return false;
            window.open('/oasis/timecard/createNew/' + hash + '/' + lastWeekEnding, '_blank');
        },

        // When a term form is selected, update the list of custom document fields
        updateTermFormFields() {
            let newFields = {};
            let forms = [];

            // Get form fields
            this.termFormsAvailable.map(doc => {
                if (this.selectedTermForms.includes(doc.id) && doc.fields && Array.isArray(doc.fields) && doc.fields.length) {
                    forms.push(doc);
                    doc.fields.map(formField => {
                        newFields[formField.field] = { id: formField.id, name: formField.field, label: formField.name, type: formField.type, required: formField.required, length: formField.length, sortOrder: formField.sort_order }
                    })
                }
            })
            this.termForms = forms;
            this.termFormFields = Object.assign({}, newFields);
        },

        // Probably good forMixins!
        flatten(array) {
            array.reduce((acc, cur) => acc.concat(Array.isArray(cur) ? cur : []), []);
        },

        async getBatches() {
            const response = await this.oasisApi.get('/batches')
            this.batches = (response.data || {}).count > 0 ? response.data.results : [];
            return this.batches;
        },

        updateBatch(batchId) {
            if (!batchId && !this.move_batch.id) return false
            else if (!batchId) batchId = this.move_batch.id

            const batch = this.batches.find((batch) => parseInt(batch.id) === parseInt(batchId))
            this.move_batch.id = batchId
            this.move_batch.name = batch.name
        },

        closeBatchModal() {
            this.batchModal = false;
        },

        closeAddBatchModal() {
            this.newBatch.name = '';
            this.newBatch.week_ending = '';
            this.newBatch.description = '';
            this.newBatch.department_id = '';
            this.newBatch.signatory_name = '';
            this.newBatch.is_union = '';
            this.newBatch.status = 1;
            this.addBatchModal = false;
        },

        // Add a new department to the current entity
        async changeBatch(selected, timecardList, new_batch_id) {
            // if (!selected) selected = this.selectedTimecards; -> old logic
            selected = [];
            for (let row of this.rowData) {
                if (row.selected) selected.push(row.hash);
            }
            if (!timecardList) timecardList = this.timecards;
            if (!new_batch_id) new_batch_id = this.move_batch.id;
            this.updateBatch();

            if (selected.length === 0 && typeof selected !== 'function') {
                this.createDialog({ "title": "Error", "body": 'Please select at least one timecard to change.', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }
            if (typeof selected === 'function') selected = selected();

            if (!new_batch_id) {
                this.createDialog({ "title": "Error", "body": 'Please select the batch to change.', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }

            // Make each one match.  Can't wait to use REST Resource...
            await this.changeApi('changebatch', selected);
            selected.forEach((tcHash) => {
                let tc = timecardList.find(t => t.hash === tcHash) || {};
                tc.batch_id = this.move_batch.id;
                tc.batch = this.move_batch.name;
            })

            this.batchModal = false;
            this.move_batch = {
                id: undefined,
                name: undefined,
            }
            this.rowHashData = new Map();
            this.selectedBatch = {};
        },

        openAddBatchModal() {
            this.addBatchModal = true;
        },
        updateWeekEnding: _.debounce(function (weekEnding) {
            let date = new Date(weekEnding);

            // Set hours from Calendar to 10 to handle all timezones
            if (date.getHours() === 0) {
                date.setHours(10);
                weekEnding = date;
            }

            if (! weekEnding) {
                this.isDisabled = true;
                return;
            } else if (this.disabled.includes(date.getDay())) {
                this.isDisabled = true;
                this.createDialog({ "title": "Error", "body": 'This date is not allowed.', "buttonNo": false, "buttonYesLabel": "OK" });
                return;
            }
            this.isDisabled = false;
            this.newBatch.week_ending = weekEnding;
            this.autoGenerateNewBatchName();
        }, 100),

        async addBatch() {
            if (this.checkForm("#addBatchForm")) {
                let method = 'post';

                this.newBatch.entity_id = this.entityId || null;
                this.newBatch.union_local_id = (this.assignment || {}).union_local_id || null;
                if (!this.newBatch.department_id) this.newBatch.department_id = null;

                this.oasisApi[method]('/batches', this.newBatch)
                    .then(response => {
                        if (response.status == 200 || response.status == 201) {
                            this.closeAddBatchModal();
                            if (response.data.count === 1) {
                                return response.data.results[0];
                            }
                            else return false;
                        } else if (response.status == 400 || response.status == 422) {
                            if (Array.isArray(response.data.errorMessages)) {
                                const errorMessages = response.data.errorMessages;
                                let message = '';
                                for (const i in errorMessages) {
                                    if (typeof errorMessages[i].message !== 'string') continue;
                                    $("#addBatchForm input[name='" + errorMessages[i].field + "']").addClass('form-error2');
                                    message += (errorMessages[i].message + "\n") || '';
                                }
                                this.createDialog({ "title": "Error", "body": message, "buttonNo": false, "buttonYesLabel": "OK" });
                            } else {
                                this.createDialog({ "title": "Error", "body": response.data.message || 'Error adding the field.', "buttonNo": false, "buttonYesLabel": "OK" });
                            }
                            return false;
                        } else {
                            this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                            return false;
                        }
                    })
                    .then(async (result) => {
                        if (!result) return false;
                        // Refresh
                        await this.getBatches();
                    })
                    .catch(error => {
                        console.log('error: '); console.log(error);
                    });
            }
        },
        async editBatchInfo() {
            if (this.checkForm("#editBatchForm")) {
                if (this.isBatchChanged) {
                    let method = 'patch';

                    // only three values can be changed. - name, description, department_id
                    let data = {id: this.editBatch.id, entity_id: this.entityId, name: this.editBatch.name.trim(), description: this.editBatch.description, department_id: this.editBatch.department_id ? this.editBatch.department_id : null};
                    this.oasisApi[method](`/batches/${this.editBatch.id}`, data)
                        .then(response => {
                            if (response.status == 200 || response.status == 201) {
                                this.editBatchModal = false;
                                if (response.data.count === 1) {
                                    // for reactivity in frontend. only this condition will be ran when batch name was changed
                                    let nameChanged = this.editBatch.name.trim() != this.batchesFilterToApprove.trim() ? true : false;
                                    if (nameChanged) {
                                        this.batchesToApprove.unshift(response.data.results[0].name);
                                        let oldNameIdx = this.batchesToApprove.findIndex((ele) => ele == this.batchesFilterToApprove);
                                        this.batchesToApprove.splice(oldNameIdx,1);
                                        for (let timecard of this.unapprovedTimecards) {
                                            if (timecard.batch == this.batchesFilterToApprove) timecard.batch = response.data.results[0].name;
                                        }
                                        this.batchesFilterToApprove = response.data.results[0].name;
                                    }
                                    return response.data.results[0];
                                }
                                else return false;
                            } else if (response.status == 400 || response.status == 422) {
                                if (Array.isArray(response.data.errorMessages)) {
                                    const errorMessages = response.data.errorMessages;
                                    let message = '';
                                    for (const i in errorMessages) {
                                        if (typeof errorMessages[i].message !== 'string') continue;
                                        $("#editBatchForm input[name='" + errorMessages[i].field + "']").addClass('form-error2');
                                        message += (errorMessages[i].message + "\n") || '';
                                    }
                                    this.createDialog({ "title": "Error", "body": message, "buttonNo": false, "buttonYesLabel": "OK" });
                                } else {
                                    this.createDialog({ "title": "Error", "body": response.data.message || 'Error editing the field.', "buttonNo": false, "buttonYesLabel": "OK" });
                                }
                                return false;
                            } else {
                                this.createDialog({ "title": "Alert", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                                return false;
                            }
                        })
                        .then(async (result) => {
                            if (!result) return false;
                            // Refresh
                            await this.getBatches();
                            this.isBatchChanged = false;
                        })
                        .catch(error => {
                            console.log('error: '); console.log(error);
                        });
                } else {
                    this.editBatchModal = false;
                }
            }
        },

        // Easy validation, e.g. if fields are required
        checkForm(form) {
            let isMissing = false;
            let isError = false;
            if (form) {
                var scope = [ form + " input", form + " select" ];
            } else {
                var scope = [ "input", "select" ];
            }

            $.each(scope, function (index, value) {
                $(value).filter(".form-error2").each(function(ind, field){
                    $(field).removeClass("form-error2");
                });

                $(value).filter(".form-error").each(function(ind, field){
                    if (!isError) isError = true;
                });

                $(value).filter("[required]:visible").each(function(ind, field){
                    $(field).removeClass("form-missing");

                    if ($(field).val() == "") {
                        $(field).addClass("form-missing");
                        if (!isMissing) isMissing = true;
                    } else {
                        $(field).removeClass("form-missing");
                    }
                });
            });

            if (isMissing) {
                this.createDialog({ "title": "Warning", "body": 'Please add missing data before submitting.', "buttonNo": false, "buttonYesLabel": "OK"  });
                return false;
            } else if (isError) {
                this.createDialog({ "title": "Warning", "body": 'Please fix errors before submitting.', "buttonNo": false, "buttonYesLabel": "OK"  });
                return false;
            } else {
                return true;
            }
        },
        getJson(json) {
            return new Promise((resolve, reject) => {
                let data = { json: json }
                this.oasisApiProd.post('/addJson', data)
                    .then(response => {
                        if (response.status === 200) {
                            return resolve(response.data);
                        } else {
                            return reject(response);
                        }
                    })
                    .catch(error => reject(error));
                ;
            });
        },

        getReport(url, type) {
            return new Promise((resolve, reject) => {
                let data = { url: url }
                this.oasisApiProd.post('/getReport/' + type, data)
                    .then(response => {
                        if (response.status === 200) {
                            return resolve(response.data);
                        } else {
                            return reject(response);
                        }
                    })
                    .catch(error => reject(error));
                ;
            });
        },

        getSpreadsheet(url) {
            return new Promise((resolve, reject) => {
                let data = { url: url }
                this.oasisApiProd.post('/getSpreadsheet', data)
                    .then(response => {
                        if (response.status === 200) {
                            return resolve(response.data);
                        } else {
                            return reject(response);
                        }
                    })
                    .catch(error => reject(error));
                ;
            });
        },

        sendStartReminders(selected) {
            if (!selected || (selected.length === 0 && typeof selected !== 'function')) {
                this.createDialog({ "title": "Error", "body": 'Please select at least one start to send', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }
            if (typeof selected === 'function') selected = selected();

            let data = {
                "hashes": selected
            };

            // console.log(data);
            this.waiting = true;

            this.oasisApi.post('/reminder/startee', data)
                .then(response => {
                    if (response.status == 200) {
                        this.createDialog({ "title": "Success", "body": response.data.message || response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                    } else if (response.status == 400) {
                        if (response.data.message) {
                            this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else {
                            this.createDialog({ "title": "Error", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                        }
                    } else {
                        this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                    }
                    this.waiting = false;
                })
                .catch(error => {
                    console.log('error: '); console.log(error); alert(error);
                    this.waiting = false;
                });
        },

        sendTimecardReminders(selected) {
            if (!selected || (selected.length === 0 && typeof selected !== 'function')) {
                this.createDialog({ "title": "Error", "body": 'Please select at least one reminder to send', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }
            if (typeof selected === 'function') selected = selected();

            let data = {
                "hashes": selected
            };

            // console.log(data);
            this.waiting = true;

            this.oasisApi.post('/reminder/missingTc', data)
                .then(response => {
                    if (response.status == 200) {
                        this.createDialog({ "title": "Success", "body": response.data.message || response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                    } else if (response.status == 400) {
                        if (response.data.message) {
                            this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else {
                            this.createDialog({ "title": "Error", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                        }
                    } else {
                        this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                    }
                    this.waiting = false;
                })
                .catch(error => {
                    console.log('error: '); console.log(error); alert(error);
                    this.waiting = false;
                });
        },

        sendCertificationReminders(selected) {
            if (!selected || (selected.length === 0 && typeof selected !== 'function')) {
                this.createDialog({ "title": "Error", "body": 'Please select at least one reminder to send', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }
            if (typeof selected === 'function') selected = selected();

            let data = {
                "hashes": selected
            };

            // console.log(data);
            this.waiting = true;

            this.oasisApi.post('/reminder/employeeCertifications', data)
                .then(response => {
                    if (response.status == 200) {
                        this.createDialog({ "title": "Success", "body": response.data.message || response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                    } else if (response.status == 400) {
                        if (response.data.message) {
                            this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else {
                            this.createDialog({ "title": "Error", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                        }
                    } else {
                        this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                    }
                    this.waiting = false;
                })
                .catch(error => {
                    console.log('error: '); console.log(error); alert(error);
                    this.waiting = false;
                });
        },

        exportStartsPropay(selected) {
            if (!selected || (selected.length === 0 && typeof selected !== 'function')) {
                this.createDialog({ "title": "Error", "body": 'Please select at least one start to export', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }
            if (typeof selected === 'function') selected = selected();

            let data = {
                "hashes": selected
            };

            // console.log(data);
            this.waiting = true;

            this.oasisApi.post('/export/startsPropay', data)
                .then(response => {
                    if (response.status == 200) {
                        if (response.data.count > 0 && response.data.results.errors.length > 0) {
                            // combined case - success and fail
                            let message = 'Starts Exported.<br><h3>Error</h3><hr />';;
                            for (let obj of response.data.results.errors) {
                                message += `${obj.message}<br>`
                            } 
                            this.createDialog({ "title": "Success", "body": message, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else if (response.data.count > 0) {
                            // only success
                            this.createDialog({ "title": "Success", "body": "Starts Exported.", "buttonNo": false, "buttonYesLabel": "OK" });
                        } else if (response.data.results.errors.length > 0) {
                            // only fail
                            let message = '';
                            for (let obj of response.data.results.errors) {
                                message += `${obj.message}<br>`
                            } 
                            this.createDialog({ "title": "Error", "body": message, "buttonNo": false, "buttonYesLabel": "OK" });
                        }
                    } else if (response.status == 400) {
                        if (response.data.message) {
                            this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else {
                            this.createDialog({ "title": "Error", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                        }
                    } else {
                        this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                    }
                    this.waiting = false;
                })
                .catch(error => {
                    console.log('error: '); console.log(error); alert(error);
                    this.waiting = false;
                });
        },

        exportStarts(selected, hideDialog = false) {
            // hideDialog's purpose is to avoid duplicate waiting value and message.
            if (!selected || (selected.length === 0 && typeof selected !== 'function')) {
                if (!hideDialog) this.createDialog({ "title": "Error", "body": 'Please select at least one start to export', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }
            if (typeof selected === 'function') selected = selected();

            let data = {
                "hashes": selected
            };

            // console.log(data);
            if (!hideDialog) this.waiting = true;

            this.oasisApi.post('/export/starts', data)
                .then(response => {
                    if (!hideDialog) {
                        if (response.status == 200) {
                            this.createDialog({ "title": "Success", "body": response.data.message || response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else if (response.status == 400) {
                            if (response.data.message) {
                                this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                            } else {
                                this.createDialog({ "title": "Error", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                            }
                        } else {
                            this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                        }
                        this.waiting = false;
                    }
                })
                .catch(error => {
                    if (!hideDialog) {
                        console.log('error: ' + error);
                        alert(error);
                        this.waiting = false;
                    }
                });
        },

        exportTimecardsPropay(selectedEmails = null, selected, useExistingPayroll = false) {
            if (!selected || (selected.length === 0 && typeof selected !== 'function')) {
                this.createDialog({ "title": "Error", "body": 'Please select at least one timecard to export', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }
            if (typeof selected === 'function') selected = selected();

            let data = {
                "hashes": selected
            };

            if (useExistingPayroll && this.proPayPayrollId && !isNaN(this.proPayPayrollId)) {
                data.payrollId = this.proPayPayrollId;
            }

            // console.log(data);
            this.loading = true;
            // no matter export propay result, we want to send email. (run same function when we click "saved pdfs" - exportStarts)
            // simple way is to use two "for loop" but n^2 time complexity. so to reduce time complexity, use this way.
            if (selectedEmails && selectedEmails.size > 0) {
                let removeDup = new Set();

                for (let value of selectedEmails.values()) {
                    // value is assignment hash
                    // before refresh page or get updated data, need to check sentAllEmails to avoid send email on assignment that we already sent email.
                    if (this.sentAllEmails.has(value)) continue;
                    removeDup.add(value);
                    this.sentAllEmails.add(value);
                }
                if (removeDup.size > 0 ) this.exportStarts(Array.from(removeDup), true);
            }

            this.oasisApi.post('/export/timecardsPropay', data)
                .then(response => {
                    if (response.status == 200) {
                        const data = response.data.results.data
                        let message = '';
                        if (Array.isArray(data)) {
                            let total = 0;
                            let count = 0;
                            message += 'Timecards Exported. Please Click Below to check the payroll(s).<br />';
                            for (const i in data) {
                                if (!data[i] || !data[i].id) continue;
                                message += `<a target="_blank" href="${this.propayFrontend + data[i].id}">${data[i].number}</a><br/>`;
                                total += parseFloat(data[i].payLinesTotal || '0');
                                count += parseInt(data[i].assignmentCount || '0');
                            }
                            message += `# Timecards Exported: ${count}.  ProPay Gross Total: $${total}`;
                        } else {
                            message += 'Timecards Exported. Please <a target="_blank" href="' + this.propayFrontend + data.id + '">click here</a> to check the payroll.<br/>';
                            message += `# Timecards Exported: ${data.assignmentCount}.  ProPay Gross Total: $${data.payLinesTotal}`;
                        }
                        this.createDialog({
                            "title": "Success", "body": message,
                            "buttonYesLabel": "OK",
                            "buttonNoLabel": "Mark as Processed",
                            "buttonNoAction": function () { app.changeApi('process', selected); }
                        });
                    } else if (response.status == 400 || response.status == 422) {
                        if (response.data && response.data.results && response.data.results.errors) {
                            let errors = '';
                            if (typeof response.data.results.errors === 'string') {
                                errors = response.data.results.errors;
                            } else if (typeof response.data.results.errors === 'object') {
                                for (const i in (response.data.results.errors || [])) {
                                    const e = response.data.results.errors[i];
                                    errors += e.message ? e.message + '<br />' : '';
                                }
                            }
                            this.createDialog({ "title": "Error", "body": errors, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else if (response.data && response.data.errors) {
                            let errors = '';
                            if (typeof response.data.errors === 'string') {
                                errors = response.data.errors;
                            } else if (typeof response.data.errors === 'object') {
                                for (const i in (response.data.errors || [])) {
                                    const e = response.data.errors[i];
                                    errors += e.message ? e.message + '<br />' : '';
                                }
                            }
                            this.createDialog({ "title": "Error", "body": errors, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else if (response.data && response.data.message) {
                            this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else {
                            this.createDialog({ "title": "Error", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                        }
                    } else {
                        this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                    }
                    this.loading = false;
                })
                .catch(error => {
                    console.log('error: '); console.log(error); alert(error);
                    this.loading = false;
                });
        },

        exportTimecards(selected) {
            if (!selected || (selected.length === 0 && typeof selected !== 'function')) {
                this.createDialog({ "title": "Error", "body": 'Please select at least one timecard to export', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }
            if (typeof selected === 'function') selected = selected();

            let data = {
                "hashes": selected
            };

            // console.log(data);
            this.waiting = true;

            this.oasisApi.post('/export/timecards', data)
                .then(response => {
                    if (response.status == 200) {
                        this.downloadCsv(response.data.csv, response.data.name);
                    } else if (response.status == 400) {
                        if (response.data.message) {
                            this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else {
                            this.createDialog({ "title": "Error", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                        }
                    } else {
                        this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                    }
                    this.waiting = false;
                })
                .catch(error => {
                    console.log('error: '); console.log(error); alert(error);
                    this.waiting = false;
                });
        },

        exportPointZero(selected) {
            if (!selected || (selected.length === 0 && typeof selected !== 'function')) {
                this.createDialog({ "title": "Error", "body": 'Please select at least one timecard to export', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }
            if (typeof selected === 'function') selected = selected();

            let data = {
                "hashes": selected
            };

            // console.log(data);
            this.waiting = true;

            this.oasisApi.post('/export/pointzero', data)
                .then(response => {
                    if (response.status == 200) {
                        this.downloadCsv(response.data.csv, response.data.name);
                    } else if (response.status == 400) {
                        if (response.data.message) {
                            this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else {
                            this.createDialog({ "title": "Error", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                        }
                    } else {
                        this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                    }
                    this.waiting = false;
                })
                .catch(error => {
                    console.log('error: '); console.log(error); alert(error);
                    this.waiting = false;
                });
        },

        exportHotBudget(selected) {
            if (!selected || (selected.length === 0 && typeof selected !== 'function')) {
                this.createDialog({ "title": "Error", "body": 'Please select at least one timecard to export', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }
            if (typeof selected === 'function') selected = selected();

            let data = {
                "hashes": selected
            };

            // console.log(data);
            this.waiting = true;

            this.oasisApi.post('/export/hotbudget', data)
                .then(response => {
                    if (response.status == 200) {
                        this.downloadCsv(response.data.csv, response.data.name);
                    } else if (response.status == 400) {
                        if (response.data.message) {
                            this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else {
                            this.createDialog({ "title": "Error", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                        }
                    } else {
                        this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                    }
                    this.waiting = false;
                })
                .catch(error => {
                    console.log('error: '); console.log(error); alert(error);
                    this.waiting = false;
                });
        },

        downloadCsv(csvData, name) {
            if (!csvData) return false
            const filename = (name || 'Timecard') + '.csv'

            const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' })
            if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, filename)
            } else {
                let csvElement = document.createElement('a')
                var url = URL.createObjectURL(blob)
                csvElement.setAttribute('href', url)
                csvElement.setAttribute('download', filename)
                csvElement.setAttribute('target', '_blank')
                csvElement.style.visibility = 'hidden'
                document.body.appendChild(csvElement)
                csvElement.click()
                document.body.removeChild(csvElement)
            }
        },

        saveTimecardsToLocalStorage(type = 'unapprovedTimecards') {
            const startHashes = ((this[type] || []) && this[type].length) ? this[type].map((tc) => tc.hash || null) : [];
            localStorage.setItem('timecardList', JSON.stringify(startHashes));
        },

        saveStartsToLocalStorage(type = 'readyToApproveStarts') {
            const startHashes = ((this[type] || []) && this[type].length) ? this[type].map((start) => start.hash || null) : [];
            localStorage.setItem(type, JSON.stringify(startHashes));
        },

        selectedSearchTimecards() {
            return this.getSelectedHashes('timecardHistory');
        },

        getSelectedHashes(gridRef) {
            if (!gridRef || !this.$refs[gridRef] || !this.$refs[gridRef].gridOptions) return [];
            return ((this.$refs[gridRef].gridOptions.api || {}).getSelectedRows() || []).map((row) => row.hash);
        },

        async loadDashboardData() {
            const promisesNow = [
                this.loadTimecardData(),
                this.loadStartData()
            ];

            await Promise.all(promisesNow)
            this.loadAllStartData();
        },

        async loadTimecardData() {
            // Load Timecards
            const promisesTc = [
                this.oasisApi.get('/getTimecards/toApprove'), // 0
                this.oasisApi.get('/getTimecards/open'), // 1
                this.oasisApi.get('/getTimecards/approved'), // 2
                this.oasisApi.get('/getTimecards/missing'), // 3
                this.oasisApi.get('/review/timecard'), // 4
            ];

            await Promise.all(promisesTc)
                .then((responses) => {
                    this.timecards = responses[0].data.results;
                    this.timecardsOpen = responses[1].data.results;
                    this.timecardsApproved = responses[2].data.results;
                    this.timecardsMissing = responses[3].data.results;
                    this.timecardReviews = responses[4].data.results;
                })
                .catch(error => { console.log(error); })
                .finally(() => {
                    this.timecardsSubmitted = Object.assign([], this.timecardsApproved.filter((t) => t.payroll_status > 0));
                });
            ;
        },

        async loadStartData() {
            // Limit logic.  Default is 20 records
            const limit = (typeof pageType === 'undefined') ? 20 : 0;
            const promisesStarts = [
                this.oasisApi.get('/getStarts/toApprove'), // 0
                this.oasisApi.get('/getStarts/toVerifyI9'), // 1
                this.oasisApi.get('/getStarts/unapproved'), // 2
                this.oasisApi.get('/getStarts/incomplete/' + limit), // 3
                this.oasisApi.get('/getStarts/unsent'), // 4
                this.oasisApi.get('/getStarts/completedRecently'), // 5
                this.oasisApi.get('/getStarts/terminated'), // 6
            ];

            await Promise.all(promisesStarts)
                .then((responses) => {
                    this.readyToApproveStarts = responses[0].data.results;
                    this.needingI9Starts = responses[1].data.results;
                    this.openStarts = responses[2].data.results;
                    this.waitingStarts = ((responses[3] || {}).data || {}).results || [];
                    this.unsentStarts = responses[4].data.results;
                    this.recentlyCompletedStarts = responses[5].data.results.sort((a,b)=> {
                        let propayA = a.propay_id ? 1 : 0;
                        let propayB = b.propay_id ? 1 : 0;
                        if (propayA == propayB) return b.modified - a.modified;
                        return propayB - propayA;
                    });
                    this.terminatedStarts = responses[6].data.results;
                })
                .then(() => {
                    this.saveStartsToLocalStorage();
                })
                .catch(error => { console.log(error); }
            );
        },

        async loadAllStartData() {
            const promisesStarts = [
                this.oasisApi.get('/getStarts/completed'), // 0
                this.oasisApi.get('/getStarts/allStarts') // 1
            ];

            await Promise.all(promisesStarts)
                .then((responses) => {
                    this.completedStarts = responses[0].data.results;
                    this.allStarts = responses[1].data.results;
                })
                .catch(error => { console.log(error); }
            );
        },

        updateTermDate(value) {
            this.termDate = value || '';
        },

        updateEdits(edits) {
            // console.log(edits);
            if (edits && Array.isArray(edits)) {
                this.edits = edits;
            }
        },

        getPages() {
        },

        changePage(page) {
            this.pageCurrent = page;
            this.waiting = true;
            this.getTransactions('aps', page)
                .then((response) => {
                    this.transactions = response.results;
                    this.transactionCount = response.count;
                    this.waiting = false;
                })
                .catch((error) => {
                    this.waiting = false;
                    console.log(error);
                    return error;
                });
        },

        openTab(name) {
            if (!name) return;
            for (const i in this.$refs) {
                console.log(i, this.$refs[i]);
                const type = this.$refs[i].nodeName;
                const classes = this.$refs[i].classList;

                if (!classes || type !== 'LI') {
                    continue;
                } else if (i === name) {
                    $('#myTab a[href="#approved-timecards"]').tab('show');
                }
            }
        },

        // Generic test function
        log(value) {
            console.log('Logging:');
            console.log(value);
        },

        // Create a dynamic modal dialog box with buttons and labels
        createDialog(options) {
            let index = this.openModals;
            options.id = index;

            if (options.buttonYesAction) { this.buttonYesAction[index] = options.buttonYesAction;
            } else { this.buttonYesAction[index] = function () {}; }

            if (options.buttonYesLabel) { this.buttonYesLabel = options.buttonYesLabel;
            } else { options.buttonYesLabel = 'Yes'; }

            if (options.buttonNoAction) { this.buttonNoAction[index] = options.buttonNoAction;
            } else { this.buttonNoAction[index] = function () {}; }

            if (options.buttonNoLabel) { this.buttonNoLabel = options.buttonNoLabel;
            } else { options.buttonNoLabel = 'No'; }

            if (options.button3Action) { this.button3Action[index] = options.button3Action;
            } else { this.button3Action[index] = function () {}; }

            if (options.button3Label) { this.button3Label = options.button3Label;
            } else { options.button3Label = 'Maybe'; }

            this.modals.push(options);
            this.openModals++;
        },

        // Close the dynamic modal
        closeModal(index) {
            this.modals.splice(index, 1);
            this.buttonYesAction.splice(index, 1);
            this.buttonNoAction.splice(index, 1);
            this.button3Action.splice(index, 1);
            this.openModals--;
        },

        modalConfirm(index) {
            this.buttonYesAction[index]();
        },

        modalCancel(index) {
            this.buttonNoAction[index]();
        },

        modalButton3(index) {
            this.button3Action[index]();
        },

        createLink(value) {
            return value;
        },

        openWindow(link = '', target = '') {
            // console.log(link)
            let child = window.open(link, target);
            child.onunload = () => {
                this.loadDashboardData();
            };
        },

        // Wrapper for openWindow that also stores the list of timecards into localStorage
        gotoTimecard(type = 'unapprovedTimecards', link = '', target = '_blank') {
            // console.log(link)
            if (type !== 'unapprovedTimecards') this.saveTimecardsToLocalStorage(type);
            this.openWindow(link, target);
        },
    },

    watch: {
    },

    async created() {
        this.format = this.getDateFormat();
        this.propayFrontend = (typeof frontendUrl !== 'undefined' && frontendUrl) ? frontendUrl : 'https://propay.revolutiones.org/payrolls/';
        if (termForms) { this.termFormsAvailable = termForms; }
        if (typeof harassmentCertification === 'undefined') {
            this.harassmentCertification = false;
        } else {
            this.harassmentCertification = harassmentCertification;
        }
        if (typeof showEdits !== 'undefined') { this.showEdits = showEdits; }

        let now = new Date();
        let currentTime = now.getTime();
        let COAObj = JSON.parse(window.localStorage.getItem(entityId + '#'));

        /* GL will be updated below conditions
        1. there is no COAObj in LocalStorage.
        2. will be updated automatically after one week from recent update. (updating function will be ran only here)
        */ 
        if (!COAObj || (COAObj && COAObj.isLoaded == false) || (currentTime > Number(COAObj.time) + 7 * 86400000)) {
            this.getProbooksResources(currentTime);
        }

        await this.loadDashboardData();

        this.oasisApi.get('/entities')
            .then(response => {
                this.entity = response.data;
                if (response.data.hasOwnProperty('other_properties') && response.data.other_properties) {
                    const data = this.isJson(response.data.other_properties) ? JSON.parse(response.data.other_properties) : response.data.other_properties;
                    this.showBatches = data.showBatches || false;
                    this.hideMissingTimecards = data.hideMissingTimecards || false;
                    this.getBatches();
                    return response.data
                }
            })
            .then(results => {
                if (this.harassmentCertification) {
                    this.oasisApi.get('/employeeCertifications/' + this.entity.id)
                        .then(response => {
                            // console.log(response.data.results);
                            this.certifiedEmployees = response.data.results;
                        })
                        .catch(error => { console.log(error); }
                    );
                }
            })
            .catch(error => { console.log(error); }
        );

        const responseDepartments = await this.oasisApi.get('/departments')
        if (responseDepartments && responseDepartments.data && responseDepartments.data.results) this.departments = responseDepartments.data.results;

        const res = await this.oasisApi.get(`/getAllSignatories/${this.entityId}`);
        this.allSignatories = res.data;
        if (this.allSignatories.length) {
            for (let sig of this.allSignatories) {
                if (!sig.union) this.defaultSignatories.push({prefix:sig.prefix, name:sig.name});
            }
        }
    },

    beforeCreate() {
        this.oasisApi = new Axios('/restv2');
    },

    async mounted() {
        setTimeout(function () { $(function () { $('[data-toggle="tooltip"]').tooltip() }) }, 500);
        // Prevent back button from failing.
        history.pushState(null, document.referrer, location.href);
        window.onpopstate = function () {
            window.location.href = document.referrer;
        };
        this.adminAccess = typeof adminAccess !== 'undefined' ? (adminAccess ? true : false) : false;
    }
}).mount("#dashboard");

